export const LOAD_CONFIGURATOR_HIERARCHY_LEVEL_SUCCESS = "LOAD_CONFIGURATOR_HIERARCHY_LEVEL_SUCCESS";
export const LOAD_ASSET_BASE_PRICE_SUCCESS = "LOAD_ASSET_BASE_PRICE_SUCCESS";
export const LOAD_ASSET_EQUIPMENTS_SUCCESS = "LOAD_ASSET_EQUIPMENTS_SUCCESS";
export const LOAD_ASSET_EQUIPMENTS_STARTED = "LOAD_ASSET_EQUIPMENTS_STARTED";
export const INVALIDATE_CONFIGURATOR_DATA = "INVALIDATE_CONFIGURATOR_DATA";
